// Module
var code = "<svg width=26 height=25 viewBox=\"0 0 26 25\" fill=none xmlns=http://www.w3.org/2000/svg> <path d=\"M25.1248 15.5246C23.4563 22.2204 16.6726 26.2956 9.97483 24.6246C3.27708 22.9536 -0.796296 16.1733 0.874829 9.4769C2.54595 2.78052 9.32633 -1.2966 16.0226 0.37465C22.7188 2.0459 26.796 8.82665 25.1248 15.5246Z\" fill=#F7931A /> </svg> ";
// Exports
module.exports = code;